'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _files = require('./files.delete');

var _files2 = _interopRequireDefault(_files);

var _files3 = require('./files.info');

var _files4 = _interopRequireDefault(_files3);

var _files5 = require('./files.list');

var _files6 = _interopRequireDefault(_files5);

var _files7 = require('./files.upload');

var _files8 = _interopRequireDefault(_files7);

var _filesComments = require('./files.comments.add');

var _filesComments2 = _interopRequireDefault(_filesComments);

var _filesComments3 = require('./files.comments.delete');

var _filesComments4 = _interopRequireDefault(_filesComments3);

var _filesComments5 = require('./files.comments.edit');

var _filesComments6 = _interopRequireDefault(_filesComments5);

var _files9 = require('./files.revokePublicURL');

var _files10 = _interopRequireDefault(_files9);

var _files11 = require('./files.sharedPublicURL');

var _files12 = _interopRequireDefault(_files11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  delete: _files2.default,
  info: _files4.default,
  list: _files6.default,
  upload: _files8.default,
  comments: {
    add: _filesComments2.default,
    delete: _filesComments4.default,
    edit: _filesComments6.default
  },
  revokePublicURL: _files10.default,
  sharedPublicURL: _files12.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/slack/methods/files.js
// module id = 428
// module chunks = 0